import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { getSizeToken, getVariantToken, marginBottomSpacing } from '@koaly/mixins';
import React from 'react';
import styled from 'styled-components';
import { useLinkWrapper } from '../../hooks/useLinkWrapper.js';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../Button/ButtonGroup/ButtonGroup.js';
import { Heading } from '../Heading/Heading.js';
import { Paragraph } from '../Paragraph/Paragraph.js';

const StyledCard = styled.article `
  border-radius: ${getSizeToken('card', 'borderRadius')};
  color: ${getVariantToken('card', 'color')};
  background-color: ${getVariantToken('card', 'backgroundColor')};
  padding: ${getSizeToken('card', 'padding')};

  ${({ theme }) => `box-shadow: ${theme.elevations[2]};`};
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
  text-align: left;
`;
const Header = styled.header `
  display: flex;
`;
const Right = styled.div `
  margin-left: auto;
  padding-left: 10px;
  text-align: right;
`;
const Card = ({ title, titleOnClick, children, titleSpaceAfter, buttons, right, spaceAfter, className, }) => {
    const linkWrap = useLinkWrapper();
    return (React.createElement(StyledCard, { spaceAfter: spaceAfter, className: className },
        right && (React.createElement(Header, null,
            React.createElement(Heading, { onClick: titleOnClick, size: "h4", as: "h3", spaceAfter: titleSpaceAfter !== null && titleSpaceAfter !== void 0 ? titleSpaceAfter : 6 }, title),
            React.createElement(Right, null, right))),
        !right && (React.createElement(Heading, { size: "h4", spaceAfter: 6 }, title)),
        React.createElement(Paragraph, { spaceAfter: buttons && 16 }, children),
        buttons &&
            React.createElement(ButtonGroup, { spacing: 4 }, buttons.map((_a, i) => {
                var { label } = _a, rest = __rest(_a, ["label"]);
                return linkWrap(React.createElement(Button, Object.assign({ key: i + '-button-topbar' }, rest, { size: "medium", elevation: 2 }), label));
            }))));
};

export { Card };
//# sourceMappingURL=Card.js.map
